export default {
  login: '/api/auth/login',
  logout: '/api/auth/logout',
  entities: '/api/entities',
}